import { atom } from 'jotai';
import { $CurrentUserLinkName } from '@user/shared/atoms/current-user';
import { $UserFollowingTopic } from 'shared/atoms';

export const $CurrentUserFollowingTopic = atom((get) => {
  const userLinkName = get($CurrentUserLinkName);
  return get($UserFollowingTopic(userLinkName));
});
